<template>
	<div class="modal-body">
		<div class="row">
			<s-form cod="10" v-model="data.metadata" />
		</div>
	</div>
</template>
<script>
	import sForm from 'app/sForm';
	export default {
		name: 'userMdMetadata',
		props: ['dataIn'],
		components: {
			sForm,
		},
		computed: {
			data() {
				return this.dataIn;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/settings/users/modal/metadata.vue